import React, { useEffect } from 'react';
import { isCountryPortugal } from 'utilities/multiLanguageHelper';
import { ModalComponent } from 'components/modal/modalComponent';
import { FormattedText } from 'core/i18n';
import { doTagShowTransferIdentificationModal } from './tagging';

export const TransferIdentificationModal = ({ showModal, handleCancel, handleContinue }) => {
    useEffect(() => {
        showModal && doTagShowTransferIdentificationModal();
    }, [showModal]);

    return (
        <ModalComponent
            isOpen={showModal}
            className="modal-step3-transfer"
            title={<FormattedText value="identification-modalCantChangeMethod" />}
            cancelText={<FormattedText value="button-goBack" />}
            closeAction={handleCancel}
            onCancel={handleCancel}
            confirmText={<FormattedText value="button-continue" />}
            onConfirm={handleContinue}
            isConfirmDisabled={!showModal}
        >
            <p>
                <FormattedText value="identification-continueConfirmation" />
            </p>
            <ul>
                <li>
                    <FormattedText value="identification-headlineOriginAccount" />
                </li>
                <li>
                    <FormattedText value="identification-mandatoryTransferAdvise" />
                </li>
                {isCountryPortugal() && (
                    <li>
                        <FormattedText value="identification-awareComissionAdvise" />
                    </li>
                )}
            </ul>
            <br />
            <p>
                <FormattedText value="identification-areYouSureToContinueTransfer" />
            </p>
        </ModalComponent>
    );
};
